<template>
  <div class="content">
    <ul>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_year_1" name="radio_year" type="radio" value="year_to_date" v-model="checked" />
          <label for="radio_year_1" class="radio-label" @click="onChangeYearToDate">{{ $t('year_to_date') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_year_2" name="radio_year" type="radio" value="last_year" v-model="checked" />
          <label for="radio_year_2" class="radio-label" @click="onChangeLastYear">{{$t('last')}}</label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.lastYear" @input="onChangeLastYear" />
          <label>{{ $t('year') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_year_3" name="radio_year" type="radio" value="form_year" v-model="checked" />
          <label for="radio_year_3" class="radio-label" @click="onChangeFromYear"></label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.formYear" @input="onChangeFromYear" />
          <label>{{ $t('year') }}, {{ $t('from') }}</label>
          <select name="day" class="input--tabs" v-model="fillterForm.year" @change="onChangeFromYearByYear">
            <option v-for="day in listYear" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import listDateTime from '@/constants/dateTime'
import tabType from '@/constants/tabType'
import modeQuery from '@/constants/modeQuery'
import moment from 'moment'
import { datetime } from '@/config'

export default {
  name: 'FilterYear',
  data () {
    return {
      listYear: listDateTime.year,
      checked: null,
      fillterForm: {
        lastYear: 4,
        formYear: 4,
        year: new Date().getFullYear()
      },
      day: {
        createdAtMin: null,
        createdAtMax: null
      }
    }
  },
  methods: {
    onChangeLastYear () {
      this.checked = tabType.YEAR.LAST_YEAR
      if (this.fillterForm.lastYear !== '') {
        this.day = {
          createdAtMin: moment()
            .subtract(Number(this.fillterForm.lastYear), datetime.YEAR)
            .startOf(datetime.YEAR)
            .toJSON(),
          createdAtMax: moment()
            .endOf(datetime.YEAR)
            .toJSON()
        }
        this.$emit('changeYear', this.day, modeQuery.YEAR, Number(this.fillterForm.lastYear))
      }
    },
    onChangeFromYear () {
      this.checked = tabType.YEAR.FORM_YEAR
      if (this.fillterForm.formYear !== '') {
        const startYear = moment(`${new Date().getFullYear()}-01-01`)
        const endYear = moment(startYear)
          .add(Number(this.fillterForm.formYear), datetime.YEAR)
          .endOf(datetime.YEAR)
        this.day = {
          createdAtMin: startYear.toJSON(),
          createdAtMax: endYear.toJSON()
        }
        this.$emit(
          'changeYear',
          this.day,
          modeQuery.YEAR,
          Number(this.fillterForm.formYear),
          moment()
            .endOf(datetime.YEAR)
            .unix(),
          moment(this.day.createdAtMax)
            .endOf(datetime.YEAR)
            .unix()
        )
      }
    },
    onChangeYearToDate () {
      this.checked = tabType.YEAR.YEAR_TO_DATE
      const startYear = moment(`${new Date().getFullYear()}-01-01`)
      const endYear = moment().toJSON()
      this.day = {
        createdAtMin: startYear.toJSON(),
        createdAtMax: endYear
      }
      this.$emit('changeYear', this.day, modeQuery.YEAR, 0)
    },
    onChangeFromYearByYear () {
      this.checked = 'form_year'
      if (this.fillterForm.formYear !== '') {
        const startYear = moment(`${this.fillterForm.year}-01-01`)
        const endYear = moment(startYear)
          .add(Number(this.fillterForm.formYear), datetime.YEAR)
          .endOf(datetime.YEAR)
        this.day = {
          createdAtMin: startYear.toJSON(),
          createdAtMax: endYear.toJSON()
        }
        this.$emit('changeYear', this.day, modeQuery.YEAR, Number(this.fillterForm.formYear))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  .radio-btn {
    padding-bottom: 10px;
    margin: 0.5rem;
    display: flex;
    align-items: center;
    align-content: center;
  }
  .radio {
    display: flex;
    align-items: baseline;
  }
  label {
    color: #a0a8b4;
  }
  .input--tabs {
    margin: 0 8px;
    height: 32px;
    background-image: none;
    border: 1px solid #ccc;
    width: 70px;
    outline: none;
  }
}
</style>
